export const apiGqlPath = '/api/graphql';
